'use client';

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import mergeClasses from 'shared/lib/utils';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
const seperatorVariants = cva('shrink-0', {
  variants: {
    variant: {
      default: 'bg-separator',
      dark: 'bg-border'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
interface SeparatorProps extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>, VariantProps<typeof seperatorVariants> {}
const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, SeparatorProps>(({
  className,
  orientation = 'horizontal',
  variant,
  decorative = true,
  ...props
}, ref) => <SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={mergeClasses(seperatorVariants({
  variant
}), orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)} {...props} />);
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };